import { MessageItem } from 'components';

/**
 * MessageListc
 *
 * @return {JSX.Element}
 */
const MessageList = ({ messages, onClick }) => {
  const handleClick = (noticeItem) => () => onClick(noticeItem);

  return messages.map((m) => {
    const viewMessage = m.data;
    const unread = !viewMessage.hasViewed;

    return (
      <MessageItem
        key={m.id}
        message={viewMessage.messageText}
        type={viewMessage.noticeType}
        subject={viewMessage.noticeTitle}
        onClick={handleClick(m)}
        hasViewed={!unread}
        isImage={viewMessage.isImage}
        noWrap
      />
    );
  });
};

MessageList.displayName = 'MessageList';

export default MessageList;
